export const SUBSCRIPTION = {
  FREE: 0, // Free
  PAID1: 1, // Premium (pro)
  PRO_TRIAL: 2, // Pro-Trial
  PREMIUM: 1, // Premium
  FLEXI: 3, // Flexi
  MAXI: 4, // Maxi
  SCHEDULING_ONLY: 5, // Scheduling only,
  TIMESHEET_ONLY: 6,
  ENTERPRISE: 10, // Enterprise
  PREMIUM_YEARLY: 11, // Yearly Premium
  MOBILE_ONLY: 20, // Mobile Only
  FREEMIUM: 30, // Freemium
};

export const SUBSCRIPTION_INDEX = {
  0: 'FREE',
  1: 'PREMIUM', // PAID1
  2: 'PRO_TRIAL',
  3: 'FLEXI',
  4: 'MAXI',
  5: 'SCHEDULING_ONLY',
  6: 'TIMESHEET_ONLY',
  10: 'ENTERPRISE',
  11: 'PREMIUM_YEARLY',
  20: 'MOBILE_ONLY',
  30: 'FREEMIUM',
};

export function isFree() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.FREE;
}

// TODO: move this helper function to a more appropriate place
export function getMarketplaceAppUrl() {
  return window.$dt?.objMyInstallInfo.ThirdPartyUpdateUrl;
}

export function isPaused() {
  return window?.DP_SUBSCRIPTION_PAUSED;
}

export function isPro() {
  return (
    window?.DP_SUBSCRIPTION === SUBSCRIPTION.PAID1 ||
    window?.DP_SUBSCRIPTION > SUBSCRIPTION.PRO_TRIAL
  );
}

export function isProTrial() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.PRO_TRIAL;
}

export function isNotFree() {
  return window?.DP_SUBSCRIPTION > SUBSCRIPTION.FREE;
}

export function isPremium() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.PREMIUM;
}

export function isFlexi() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.FLEXI;
}

export function isMaxi() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.MAXI;
}

export function isSchedulingOnly() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.SCHEDULING_ONLY;
}

export function isTimesheetOnly() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.TIMESHEET_ONLY;
}

export function isEnterprise() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.ENTERPRISE;
}

export function isYearly() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.PREMIUM_YEARLY;
}

export function isYearlyPremium() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.PREMIUM_YEARLY;
}

export function isMobileOnly() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.MOBILE_ONLY;
}

export function isFreemium() {
  return window?.DP_SUBSCRIPTION === SUBSCRIPTION.FREEMIUM;
}

export function isPaid() {
  return !isFree() && !isFreemium() && !isProTrial();
}

export function getSubscriptionName(subscription) {
  return SUBSCRIPTION_INDEX[subscription] || '';
}
